import dayjs from "dayjs";
import tz from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
export default function useDayjs() {
  dayjs.extend(utc);
  dayjs.extend(tz);
  const locTimeZone = LocalStorage.getItem("TIME_ZONE");
  const userTimeZone = dayjs.tz.guess();
  const currTimeZone = locTimeZone || userTimeZone;
  return {
    dayjs,
    userTimeZone: currTimeZone,
  };
}
